export const upgradeLoansData = [
  {
    name: 'loanPayments',
    titleId: 'loans.loanPayments.title',
    hasFlagProp: 'hasLoans',
    countField: {
      name: 'loanPaymentsCount',
      emptyTextKey: 'loans.loanPaymentsCount.title',
    },
    totalRepayField: {
      name: 'totalRepayments',
      titleId: 'loans.totalRepayments.title',
    },
    freqFieldName: {
      name: 'frequency',
    },
  },
  {
    name: 'smallLoanPayments',
    titleId: 'loans.smallLoanPayments.title',
    subtitleId: 'loans.smallLoanPayments.hint',
    hasFlagProp: 'hasSmallLoans',
    dependsOn: 'hasLoans',
    countField: {
      name: 'smallLoanPaymentsCount',
      emptyTextKey: 'loans.loanPaymentsCount.title',
    },
    totalRepayField: {
      name: 'smallLoanPaymentsTotalRepayments',
      titleId: 'loans.totalRepayments.title',
    },
    freqFieldName: {
      name: 'smallLoanPaymentsFrequency',
    },
  },
  {
    name: 'creditCards',
    titleId: 'loans.creditCards.title',
    hasFlagProp: 'hasCreditCards',
    countField: {
      name: 'creditCardsCount',
      emptyTextKey: 'loans.creditCardsCount.title',
      gridClass: 'one-half palm-one-whole',
    },
    totalRepayField: {
      name: 'totalLimit',
      titleId: 'loans.totalLimit.title',
      gridClass: 'one-half palm-one-whole',
    },
  },
];

export const loansData = [
  {
    name: 'payAdvancePayments',
    titleId: 'loan.payAdvancePayments.title',
    tooltipId: 'loan.payAdvancePayments.tooltip',
    hasFlagProp: 'hasPayAdvanceLoans',
    countField: {
      name: 'payAdvancePaymentsCount',
      emptyTextKey: 'loan.payAdvancePayments.count',
    },
    totalRepayField: {
      name: 'payAdvancePaymentsTotalRepayments',
      titleId: 'loans.totalRepayments.title',
      hintKey: 'loans.totalRepayments.error',
    },
    freqFieldName: {
      name: 'payAdvancePaymentsFrequencies',
    },
  },
  {
    name: 'creditCards',
    titleId: 'loan.creditCards.title',
    tooltipId: 'loan.creditCards.tooltip',
    hasFlagProp: 'hasCreditCards',
    countField: {
      name: 'creditCardsCount',
      emptyTextKey: 'loan.creditCards.count',
      gridClass: 'one-half palm-one-whole',
    },
    totalRepayField: {
      name: 'totalLimit',
      titleId: 'loan.creditCards.totalLimit',
      hintKey: 'loans.totalRepayments.error',
      gridClass: 'one-half palm-one-whole',
    },
  },
  {
    name: 'smallLoanPayments',
    titleId: 'loan.smallLoanPayments.title',
    tooltipId: 'loan.smallLoanPayments.tooltip',
    hasFlagProp: 'hasSmallLoans',
    countField: {
      name: 'smallLoanPaymentsCount',
      emptyTextKey: 'loan.smallLoanPayments.count',
    },
    totalRepayField: {
      name: 'smallLoanPaymentsTotalRepayments',
      titleId: 'loans.totalRepayments.title',
      hintKey: 'loans.totalRepayments.error',
    },
    freqFieldName: {
      name: 'smallLoanPaymentsFrequency',
      gridClass: 'one-third palm-one-whole',
    },
  },
  {
    name: 'homeLoanPayments',
    titleId: 'loan.homeLoanPayments.title',
    tooltipId: 'loan.homeLoanPayments.tooltip',
    hasFlagProp: 'hasHomeLoans',
    totalRepayField: {
      name: 'homeLoanPaymentsTotalRepayments',
      titleId: 'loan.homeLoanPayments.totalRepayments',
      hintKey: 'loans.totalRepayments.error',
      gridClass: 'one-half palm-one-whole',
    },
    freqFieldName: {
      name: 'homeLoanPaymentsFrequency',
      gridClass: 'one-half palm-one-whole',
    },
  },
  {
    name: 'otherLoanPayments',
    titleId: 'loan.otherLoanPayments.title',
    tooltipId: 'loan.otherLoanPayments.tooltip',
    hasFlagProp: 'hasOtherLoans',
    countField: {
      name: 'otherLoanPaymentsCount',
      emptyTextKey: 'loan.otherLoanPayments.count',
    },
    totalRepayField: {
      name: 'otherLoanPaymentsTotalRepayments',
      titleId: 'loans.totalRepayments.title',
      hintKey: 'loans.totalRepayments.error',
    },
    freqFieldName: {
      name: 'otherLoanPaymentsFrequency',
    },
  },
];
